/* contact form validation */
$('#contact-form input[type="text"], #contact-form input[type="email"], #contact-form textarea').on('focus', function() {
  $(this).removeClass('input-error');
});

$('#contact-form').on('submit', function(e) {
  $(this).find('input[type="text"], input[type="email"], textarea').each(function() {
    if ($(this).val() == "") {
      e.preventDefault();
      $(this).addClass('input-error');
    } else {
      $(this).removeClass('input-error');
    }
  });
});

function hideFacebookPopup() {
  var _popup = $(".fb-customerchat iframe");
    
  if ($(_popup).length > 0 && $(_popup).hasClass('fb_customer_chat_bounce_in_v2')) {
  	 $(_popup).css('max-height', '0');
  	 $(_popup).removeClass('fb_customer_chat_bounce_in_v2');
  	 $(_popup).addClass('fb_customer_chat_bounce_out_v2');
  } else {
    setTimeout(function() {
      hideFacebookPopup();
    }, 100);
  }
}

var _item_count = 0;
$(document).ready(function(){
  
  hideFacebookPopup();
  
  if($('.shopify-challenge__container').length){
    $('.shopify-challenge__container').closest('#MainContent').css('background-color', '#333');
  }
  var transimg = '//suppaclub.com.au/cdn/shop/t/45/assets/trans_34.png?v=14673238622777285691788149089';
 
  
	var feed = new Instafeed({
		get: 'user',
      	accessToken: '2108174441.1677ed0.53cee2c08e264f48a1a15ee7d90e6d9a',
      	userId:'2108174441',
      template: '<a href="{{link}}"><div class="img-item" style="background-image:url({{image}});"><img src="' + transimg + '" class="item"/></div></a>',
      	limit: 5,
      	resolution: 'standard_resolution'
    });
    feed.run();
  
  
  /*check for delivery rate added in cart or not*/
  jQuery.getJSON('/cart.js', function(r){
    $.each(r.items, function(i, item){
      if(item.product_type != 'Delivery Rate'){
        _item_count = (_item_count + parseInt(item.quantity));
      }
    });
  });
  
  $('.item-qty input[type="number"]').prop('readonly', true);
  
  if($('.carousel').length){
    $('.carousel').each(function() {
      if($(this).find('.carousel-inner .item').length < 2){
        $(this).find('.carousel-inner .item:first-child').addClass('active');
        $(this).find('.carousel-control').hide();
      }
    });
  }
  
  $('.product-form-cleanse-soups-selection-section, .product-form-3daycleanse-soups-selection-section').each(function() {
  	let $form = $(this);
	var cleanse_type = $form.attr('data-cleanse');
    $('.soup-types input', $form).change(function() {
      let soup_type = $(this).val();
      $form.removeClass('type-vegetarian').removeClass('type-vegan');
      $form.addClass('type-' + soup_type.toLowerCase());
      $('.soup-types .custom-radio', $form).removeClass('selected');
      if ($(this).is(':checked')) {
        $(this).closest('.custom-radio').addClass('selected');
      }
      setCleanseMenu($form, soup_type, cleanse_type);
    });
    $('.soup-types input[value="Vegetarian"]', $form).prop('checked', true).change();
  });
  
  $('.custom-radio').each(function() {
    let $wrap = $(this);
    $('.fake-radio', $wrap).click(function() {
      let $radio = $('input', $wrap);
      $radio.prop('checked', true).change();
    });
    
  });
  
  $(document).on('click', 'a[href^="#"]:not(.no-anchor), a[href^="/#"]:not(.no-anchor)', function (e) {
    let anchor = trim($(this).attr('href'), '/');
    if(anchor !== '#') {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(anchor).offset().top
      }, 500);
    }
  });
  
});

function trim (s, c) {
  if (c === "]") c = "\\]";
  if (c === "\\") c = "\\\\";
  return s.replace(new RegExp(
    "^[" + c + "]+|[" + c + "]+$", "g"
  ), "");
}


var _cleanseOptions = {
  cleanse: {
    vegetarian: {
      "monday-breakfast": "Tumeric (Chilled)",
      "monday-lunch": "Cauliflower (Hot)",
      "monday-dinner": "Pumpkin (Hot)",
      "tuesday-breakfast": "Cucumber (Chilled)",
      "tuesday-lunch": "Zucchini (Chilled)",
      "tuesday-dinner": "Cauliflower (Hot)",
      "wednesday-breakfast": "Beetroot (Chilled, Vegetarian)",
      "wednesday-lunch": "Pumpkin (Hot)",
      "wednesday-dinner": "Zucchini (Hot)",
      "thursday-breakfast": "Tumeric (Chilled)",
      "thursday-lunch": "Cauliflower (Hot)",
      "thursday-dinner": "Pumpkin (Hot)",
      "friday-breakfast": "Zucchini (Chilled)",
      "friday-lunch": "Tumeric (Chilled)",
      "friday-dinner": "Cauliflower (Hot)"
    },
    vegan: {
      "monday-breakfast": "Tumeric (Chilled)",
      "monday-lunch": "Cauliflower (Hot)",
      "monday-dinner": "Pumpkin (Hot)",
      "tuesday-breakfast": "Beetroot (Chilled, Vegan)",
      "tuesday-lunch": "Zucchini (Chilled)",
      "tuesday-dinner": "Cauliflower (Hot)",
      "wednesday-breakfast": "Tumeric (Chilled)",
      "wednesday-lunch": "Pumpkin (Hot)",
      "wednesday-dinner": "Zucchini (Hot)",
      "thursday-breakfast": "Beetroot (Chilled, Vegan)",
      "thursday-lunch": "Cauliflower (Hot)",
      "thursday-dinner": "Pumpkin (Hot)",
      "friday-breakfast": "Zucchini (Chilled)",
      "friday-lunch": "Tumeric (Chilled)",
      "friday-dinner": "Cauliflower (Hot)"
    }
  },
  reset: {
    vegetarian: {
      "day-1-breakfast": "Tumeric (Chilled)",
      "day-1-lunch": "Cauliflower (Hot)",
      "day-1-dinner": "Pumpkin (Hot)",
      "day-2-breakfast": "Cucumber (Chilled)",
      "day-2-lunch": "Zucchini (Chilled)",
      "day-2-dinner": "Tumeric (Chilled)",
      "day-3-breakfast": "Beetroot (Chilled, Vegetarian)",
      "day-3-lunch": "Pumpkin (Hot)",
      "day-3-dinner": "Zucchini (Hot)"
    },
    vegan: {
      "day-1-breakfast": "Tumeric (Chilled)",
      "day-1-lunch": "Cauliflower (Hot)",
      "day-1-dinner": "Pumpkin (Hot)",
      "day-2-breakfast": "Beetroot (Chilled, Vegan)",
      "day-2-lunch": "Zucchini (Chilled)",
      "day-2-dinner": "Tumeric (Chilled)",
      "day-3-breakfast": "Beetroot (Chilled, Vegan)",
      "day-3-lunch": "Pumpkin (Hot)",
      "day-3-dinner": "Zucchini (Hot)"
    }
  }
};

function setCleanseMenu($form, type, cleanse_type) {
  
  var _options = _cleanseOptions.hasOwnProperty(cleanse_type) ? _cleanseOptions[cleanse_type] : _cleanseOptions['cleanse'];
  _options = _options[type === 'Vegetarian' ? 'vegetarian' : 'vegan'];
  
  $.each(_options, function(key, value) {
    $('select#' + key).val(value);
    
  });
  
}

$(document).ready(function() {
  
  $('.grid-view-item__clickable .grid-view-item__image').click(function(e) {
    
    var _redirect = $(this).parent().find('a.build-a-box__pick-soups').attr('href');
    
    if (typeof _redirect !== 'undefined') {
      window.location.href = _redirect;
    } else {
        $(this).parent().find('button.button').click();
    }
  });
  
});











